import api from './../../api/booking.js'

const booking = {
  state: {
    allPlateInfo: {},
    bookPackageInfo: '',
    recommendBerthInfo: '',
    parkInfo: '',
    berthtype: '',
    berth: [],

    /* 申领资料 */
    auditInfo: [],
    isInfoComplete: false
  },
  actions: {
    commitBerthInfo({ commit }, val) {
      api.getBerthInfo(val).then(data => {
        commit('getBerthInfo', data)
      })
    },
    commitBookPackageInfo({ commit }, val) {
      return new Promise((resolve) => {
        api.getBookPackageInfo(val).then(data => {
          commit('getBookPackageInfo', data)
          resolve()
        })
      })
    },
    commitAllPlateInfo({ commit }) {
      return new Promise(resolve => {
        api.getAllPlateInfo().then(data => {
          if (data && data.list) {
            var defaultPlate = data.list.find((v) => {
              return v.isDefault == 1
            })
            commit('getAllPlateInfo', defaultPlate)
          }
          resolve()
        })
      })
    },
    commitRecommendBerthInfo({ commit }, val) {
      api.getRecommendBerthInfo(val).then(data => {
        commit('getRecommendBerthInfo', data)
      })
    },
    commitParkingDetail({ commit }, val) {
      api.getParkingDetail(val).then(data => {
        commit('getParkingDetail', data)
      })
    },
    commitParkingBerthType({ commit }, val) {
      api.getParkingBerthType(val).then(data => {
        if (data.capacity) {
          commit('getBerthType', data.capacity)
        } else {
          commit('getBerthType', '0')
        }
      })
    }
  },
  mutations: {
    getBerthInfo(state, data) {
      state.berth = data
    },
    getBookPackageInfo(state, data) {
      state.bookPackageInfo = data
    },
    getAllPlateInfo(state, data) {
      state.allPlateInfo = data
    },
    getRecommendBerthInfo(state, data) {
      state.recommendBerthInfo = data
    },
    getParkingDetail(state, data) {
      state.parkInfo = data
    },
    getBerthType(state, data) {
      state.berthtype = data
    },
    setAuditInfo(state, data) {
      state.auditInfo = data
      if (data.length > 0) {
        state.isInfoComplete = true
      } else {
        state.isInfoComplete = false
      }
    }
  },
  getters: {
    berth: state => state.berth,
    allPlateInfo: state => state.allPlateInfo,
    bookPackageInfo: state => state.bookPackageInfo,
    recommendBerthInfo: state => state.recommendBerthInfo,
    parkInfo: state => state.parkInfo,
    berthtype: state => state.berthtype,
    auditInfo: state => state.auditInfo,
    isInfoComplete: state => state.isInfoComplete
  }
}

export default booking
